<template>
  <div>
    <personel-view-search-panel @search="search" :accessTo="1" :searchType="'io'" />

    <box class="mt-2" :title="$t('ioList')">
      <div class="ioList">
        <div v-if="list.length > 0">
          <PersonIOListWeb
            @onClickIO="onClickIO"
            :list="list"
            class="hidden-sm-and-down"
          />
          <PersonIOListMob
            @onClickIO="onClickIO"
            :list="list"
            class="hidden-md-and-up"
          />
        </div>
        <div v-else>
          <EmptyList :state="stateList" />
        </div>
      </div>
    </box>
  </div>
</template>

<script>
import PersonIOListMob from '../../components/request/PersonIOList/PersonIOListMob.vue';
import PersonIOListWeb from '../../components/request/PersonIOList/PersonIOListWeb.vue';
import StateList from "../../model/StateList";
// import PersonelViewSearchPanel from "../../components/requestManagement/PersonelViewSearchPanelWhitParam.vue";
import PersonelViewSearchPanel from "../../components/requestManagement/PersonelViewSearchPanelWhitParamJustForIO.vue";
// import PersonelViewSearchPanel from "../../components/requestManagement/PersonelViewSearchPanel.vue";
export default {
  components: {
    PersonelViewSearchPanel,
    PersonIOListWeb,
    PersonIOListMob,
  },
  data() {
    return {
      list: [],
      stateList: null,
    };
  },
  methods: {
    search(searchParams) {
      //debugger;
      const params = new URLSearchParams();
      params.append("beginDate", searchParams.beginDate);
      params.append("endDate", searchParams.endDate);
      params.append("searchKind", searchParams.searchKind);
      params.append("perno", searchParams.perno);
      this.stateList = StateList.loading();
//debugger
      this.$store.dispatch("GetIoListForArchive", { params }).then((result) => {
        //console.log(result);
        if (result.type === "success") {
          this.list = result.data;
          this.stateList = null;
        } else {
          this.list = [];
          this.stateList = StateList.error(result.error);
        }
      });
    },
    onClickIO(){},
  },
};
</script>

<style>
</style>